import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';

const LocalizedDatePicker = observer(
  ({
    onClose,
    disablePast,
  }: {
    onClose: (value: Date | null) => void;
    disablePast?: boolean;
  }) => {
    const [value, setValue] = useState<Dayjs | null>(dayjs());

    const handleChange = (newValue: Dayjs | null) => {
      setValue(newValue);
      onClose(dayjs(newValue).toDate());
    };

    return (
      <Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            format="DD/MM/YYYY"
            disablePast={disablePast === undefined ? true : disablePast}
            value={value}
            onChange={handleChange}
          />
        </LocalizationProvider>
      </Box>
    );
  },
);

export default LocalizedDatePicker;
